export default "__VITE_PUBLIC_ASSET__5da6bb41__"